import React from 'react';
import styled from 'styled-components';
import { variants } from '../theme';

const StyledButton = styled.button`
  padding: ${props => props.size === 'large' ? '12px 24px' : '8px 16px'};
  background-color: ${props => {
    if (props.disabled) return '#ccc';
    return variants[props.variant]?.background || variants.primary.background;
  }};
  color: ${props => {
    if (props.disabled) return '#666';
    return variants[props.variant]?.color || variants.primary.color;
  }};
  border: ${props => {
    if (props.disabled) return 'none';
    return variants[props.variant]?.border || 'none';
  }};
  border-radius: 4px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: ${props => props.size === 'large' ? '1rem' : '0.9rem'};
  transition: all 0.2s ease;
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  
  &:hover {
    background-color: ${props => {
      if (props.disabled) return '#ccc';
      return variants[props.variant]?.hoverBackground || variants.primary.hoverBackground;
    }};
  }
  
  &:active {
    background-color: ${props => {
      if (props.disabled) return '#ccc';
      return variants[props.variant]?.activeBackground || variants.primary.activeBackground;
    }};
  }
  
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    color: #666;
    border: none;
  }
`;

const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'medium',
  type = 'button',
  disabled = false,
  fullWidth = false,
  ...rest 
}) => {
  return (
    <StyledButton 
      onClick={onClick} 
      variant={variant} 
      size={size}
      type={type}
      disabled={disabled}
      fullWidth={fullWidth}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
